import { default as MeasurablesList } from './MeasurablesList';

export default MeasurablesList;
